// RydeSync path helpers for consistent room and session path construction
export const rsRoom = (roomId: string) => `rydesync/rooms/${roomId}`;
export const rsSession = (roomId: string) => `${rsRoom(roomId)}/session`;

// Echoverse path helpers for band assets
export const imgPath = (bandSlug: string, filename: string) => 
  `/divisions/echoverse/bands/${bandSlug}/${filename}`;

export const previewPath = (bandSlug: string, trackSlug: string, format: 'opus' | 'm4a') => 
  `/divisions/echoverse/bands/${bandSlug}/previews/${trackSlug}.${format}`;